import { render, staticRenderFns } from "./AddressOptional.vue?vue&type=template&id=38002455"
import script from "./AddressOptional.vue?vue&type=script&lang=js"
export * from "./AddressOptional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports